import { type GridSelectionModel } from "@mui/x-data-grid-pro";
import {
  type AxiosInstance,
  type AxiosResponse,
  HttpStatusCode,
  isAxiosError,
} from "axios";
import { getAttachedFileNameFromHeader } from "@/utils/utils";
import fileDownload from "js-file-download";
import { SendToTrackingService } from "@/api/handlers/errors";

interface IRequests {
  ids: GridSelectionModel; // モニタリング詳細テーブル（CommercialMonitoringDetail）のIDの配列
}

/**
 * モニタリング登録をCSVファイルとしてダウンロードするAPIを実行する。
 * @param {AxiosInstance} apiClient
 * @param {IRequests} requests
 */
export const GetCommercialMonitoringAsFileAPI = async (
  apiClient: AxiosInstance,
  requests: IRequests
): Promise<void> => {
  const urlWithParams =
    "/commercial-monitoring/file/?" +
    new URLSearchParams(
      requests.ids?.map((id) => {
        return ["id", String(id)];
      }) ?? []
    ).toString();

  try {
    const response = await apiClient.get<Blob>(urlWithParams, {
      responseType: "blob",
    });
    const filename = getAttachedFileNameFromHeader(
      response,
      "commercial-registration-monitoring-export-data.csv"
    );
    fileDownload(response.data, filename);
  } catch (error) {
    if (
      isAxiosError<AxiosResponse>(error) &&
      (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
    ) {
      SendToTrackingService(error);
    }
    throw error;
  }
};
